export const HIGH_PRECISION_SECURITY_TYPES = new Set([
  'CUR',
  'CEF',
  'CEFH',
  'MMF',
  'OEF',
  'ETP',
]);

const DEFAULT_PRECISION = 2;

export function formatValue(value?: number | null, precision?: number) {
  if (value === undefined || value === null) {
    return '';
  }

  return value.toLocaleString('en-US', {
    minimumFractionDigits: precision ?? DEFAULT_PRECISION,
    maximumFractionDigits: precision ?? DEFAULT_PRECISION,
  });
}

export function formatChange(changeValue: number, precision?: number) {
  if (changeValue <= 0) {
    return formatValue(changeValue, precision).replace('-', '–');
  }

  return `+${formatValue(changeValue, precision)}`;
}

export function getLabel(percent: string, price?: string | false | 0) {
  if (price) {
    return `Current price is ${price}. Current percentage change is ${percent}%.`;
  }

  return `Current percentage change is ${percent}%.`;
}
